/**
 * Shop Deals Section JS
 * Handles slider navigation, touch/mouse drag-scroll, and button states.
 */

(function () {
  function initShopDeals(section) {
    if (!section || section.dataset.shopDealsInitialized) return;
    section.dataset.shopDealsInitialized = 'true';

    const container = section.querySelector('[data-deals-container]');
    const prevBtn = section.querySelector('[data-slider-prev]');
    const nextBtn = section.querySelector('[data-slider-next]');
    const track = section.querySelector('[data-deals-track]');

    if (!container || !track) return;

    // Check if slider is active
    function getScrollStep() {
      const firstItem = track.querySelector('.shop-deals__item');
      if (!firstItem) return 240;
      const gap = parseInt(window.getComputedStyle(track).gap, 10) || 16;
      return firstItem.offsetWidth + gap;
    }

    function updateNavState() {
      if (!prevBtn && !nextBtn) return;

      const maxScroll = container.scrollWidth - container.clientWidth;
      const currentScroll = container.scrollLeft;

      if (prevBtn) {
        prevBtn.disabled = currentScroll <= 5;
      }

      if (nextBtn) {
        nextBtn.disabled = currentScroll >= maxScroll - 5;
      }
    }

    if (prevBtn) {
      prevBtn.addEventListener('click', () => {
        const step = getScrollStep();
        container.scrollBy({ left: -step, behavior: 'smooth' });
      });
    }

    if (nextBtn) {
      nextBtn.addEventListener('click', () => {
        const step = getScrollStep();
        container.scrollBy({ left: step, behavior: 'smooth' });
      });
    }

    let ticking = false;
    container.addEventListener('scroll', () => {
      if (!ticking) {
        window.requestAnimationFrame(() => {
          updateNavState();
          ticking = false;
        });
        ticking = true;
      }
    }, { passive: true });

    // Drag-to-scroll support for desktop
    let isDown = false;
    let startX = 0;
    let scrollLeft = 0;

    container.addEventListener('mousedown', (e) => {
      // Ignore right clicks or clicks on links/buttons directly if desired
      if (e.button !== 0) return;
      isDown = true;
      container.style.cursor = 'grabbing';
      container.style.userSelect = 'none';
      startX = e.pageX - container.offsetLeft;
      scrollLeft = container.scrollLeft;
    });

    container.addEventListener('mouseleave', () => {
      if (!isDown) return;
      isDown = false;
      container.style.cursor = '';
      container.style.userSelect = '';
    });

    container.addEventListener('mouseup', () => {
      if (!isDown) return;
      isDown = false;
      container.style.cursor = '';
      container.style.userSelect = '';
    });

    container.addEventListener('mousemove', (e) => {
      if (!isDown) return;
      e.preventDefault();
      const x = e.pageX - container.offsetLeft;
      const walk = (x - startX) * 1.5;
      container.scrollLeft = scrollLeft - walk;
    });

    // Initial check
    updateNavState();

    // Re-check on window resize
    window.addEventListener('resize', updateNavState, { passive: true });
  }

  function initAll() {
    document.querySelectorAll('[data-shop-deals]').forEach(initShopDeals);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  // Support Shopify Theme Editor dynamic section reloads
  document.addEventListener('shopify:section:load', (e) => {
    const section = e.target.querySelector('[data-shop-deals]') || (e.target.matches('[data-shop-deals]') ? e.target : null);
    if (section) {
      initShopDeals(section);
    }
  });
})();
